import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import '../Alumnos/AlumnoForm.css';
import '../Alumnos/MDAlumnos.css';
import * as constantClass from '../fileWithConstants';
import { isSubmitInProgress } from '../../services/formSubmitGuard';
import { LookupAlumnos } from '../Alumnos/LookupAlumnos';
import { LookupCarreras } from '../Carreras/LookupCarreras';

function BackIcon() {
  return (
    <svg className="md-page__icon md-page__icon--sm" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M19 12H5M12 19l-7-7 7-7" />
    </svg>
  );
}

export class UpdateAlumnoCarrera extends Component {
  static displayName = UpdateAlumnoCarrera.name;

  constructor(props) {
    super(props);
    this.state = {
      loadingInitial: true,
      loading: false,
      loadError: '',
      errorMessage: '',
      redirect: false,
      id: this.props.match.params.id,
      details: this.props.match.params.details,
      alumno: { alumnoDni: '', alumnoCodigo: 0, alumnoNombre: '' },
      carrera: { carreraCod: 0, carreraNombre: '' },
      anioInicio: new Date().getFullYear().toString(),
      showLookupStudent: false,
      showLookupCarreras: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  get isReadOnly() {
    return this.state.details === '1';
  }

  componentDidMount() {
    const canAccess = constantClass.canAccess('WWAlumnosxCarrera');
    if (canAccess) {
      this.populateData();
    } else {
      this.setState({ loadingInitial: false });
    }
  }

  clearFeedback() {
    if (this.state.errorMessage) {
      this.setState({ errorMessage: '' });
    }
  }

  handleShowStudentLookup = () => {
    if (!this.state.loading && !this.isReadOnly) {
      this.setState({ showLookupStudent: true });
    }
  };

  handleShowCarreraLookup = () => {
    if (!this.state.loading && !this.isReadOnly) {
      this.setState({ showLookupCarreras: true });
    }
  };

  handleSelectStudentItem = (e) => {
    const studentProperties = e.split('%');
    this.clearFeedback();
    this.setState({
      alumno: {
        alumnoDni: studentProperties[0],
        alumnoNombre: studentProperties[1],
        alumnoCodigo: parseInt(studentProperties[2], 10),
      },
      showLookupStudent: false,
    });
  };

  handleSelectCarreraItem = (e) => {
    const carreraProperties = e.split('%');
    this.clearFeedback();
    this.setState({
      showLookupCarreras: false,
      carrera: {
        carreraCod: parseInt(carreraProperties[0], 10),
        carreraNombre: carreraProperties[1],
      },
    });
  };

  handleHideStudentLookup = () => {
    this.setState({ showLookupStudent: false });
  };

  handleHideCarreraLookup = () => {
    this.setState({ showLookupCarreras: false });
  };

  isAnioInicioValid() {
    const year = parseInt(this.state.anioInicio, 10);
    return Number.isInteger(year) && year >= 1900 && year <= 2100;
  }

  handleAnioInicioChange = (e) => {
    this.clearFeedback();
    this.setState({ anioInicio: e.target.value });
  };

  isFormValid() {
    return (
      this.state.alumno.alumnoDni.length > 0
      && this.state.carrera.carreraNombre.length > 0
      && this.isAnioInicioValid()
    );
  }

  handleSubmit(e) {
    e.preventDefault();
    if (this.isReadOnly) {
      this.setState({ redirect: true });
      return;
    }
    if (isSubmitInProgress(this.state.loading)) return;
    if (!this.isFormValid()) {
      if (!this.isAnioInicioValid()) {
        this.setState({ errorMessage: 'Ingrese un año de inicio válido (1900–2100).' });
        return;
      }
      this.setState({ errorMessage: 'Debe seleccionar un alumno y una carrera.' });
      return;
    }
    this.saveRecord();
  }

  async populateData() {
    this.setState({ loadingInitial: true, loadError: '' });

    const { data } = await constantClass.apiFetch('api/axc/' + this.state.id, {
      method: 'GET',
    });

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data) || !data.returnModel) {
      this.setState({
        loadingInitial: false,
        loadError: constantClass.getApiErrorMessage(
          data,
          'No se pudieron cargar los datos del alumno por carrera.'
        ),
      });
      return;
    }

    const model = data.returnModel;
    this.setState({
      loadingInitial: false,
      alumno: {
        alumnoDni: model.alumnoDni || '',
        alumnoNombre: model.alumnoNombre || '',
        alumnoCodigo: model.alumnoCodigo,
      },
      carrera: {
        carreraNombre: model.carreraNombre || '',
        carreraCod: model.carreraCod,
      },
      anioInicio: model.alumnoxCarreraAnioInicio
        ? String(model.alumnoxCarreraAnioInicio)
        : new Date().getFullYear().toString(),
    });
  }

  async saveRecord() {
    if (isSubmitInProgress(this.state.loading)) return;

    this.setState({ loading: true, errorMessage: '' });

    const { data } = await constantClass.apiFetch('api/axc/update', {
      method: 'POST',
      body: JSON.stringify({
        alumnoCodigo: this.state.alumno.alumnoCodigo,
        carreraCod: this.state.carrera.carreraCod,
        alumnoxCarreraCod: parseInt(this.state.id, 10),
        alumnoxCarreraAnioInicio: parseInt(this.state.anioInicio, 10),
      }),
    });

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data) || data.returnModel === false) {
      this.setState({
        loading: false,
        errorMessage: constantClass.getApiErrorMessage(
          data,
          'No se pudo actualizar el registro. Verifique los datos e intente nuevamente.'
        ),
      });
      return;
    }

    this.setState({ loading: false, redirect: true });
  }

  renderLoading() {
    return (
      <div className="md-page md-form-page">
        <Link className="md-form-page__back" to="/md-axc">
          <BackIcon />
          Volver al listado
        </Link>
        <h1 className="md-form-page__title">
          {this.isReadOnly ? 'Detalle del Alumno por Carrera' : 'Modificar Alumno por Carrera'}
        </h1>
        <p className="md-form-page__skeleton">
          <em>Cargando datos...</em>
        </p>
      </div>
    );
  }

  renderLoadError() {
    return (
      <div className="md-page md-form-page">
        <Link className="md-form-page__back" to="/md-axc">
          <BackIcon />
          Volver al listado
        </Link>
        <h1 className="md-form-page__title">
          {this.isReadOnly ? 'Detalle del Alumno por Carrera' : 'Modificar Alumno por Carrera'}
        </h1>
        <div className="md-page__error" role="alert">
          {this.state.loadError}
        </div>
        <div className="md-form-page__actions">
          <button
            type="button"
            className="md-form-page__btn md-form-page__btn--secondary"
            onClick={() => this.populateData()}
          >
            Reintentar
          </button>
          <Link className="md-form-page__btn md-form-page__btn--primary" to="/md-axc">
            Volver al listado
          </Link>
        </div>
      </div>
    );
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/md-axc" />;
    }

    if (this.state.loadingInitial) {
      return this.renderLoading();
    }

    if (this.state.loadError) {
      return this.renderLoadError();
    }

    const { loading, errorMessage, alumno, carrera, anioInicio, showLookupStudent, showLookupCarreras } = this.state;
    const isBusy = loading;
    const readOnly = this.isReadOnly;
    const title = readOnly ? 'Detalle del Alumno por Carrera' : 'Modificar Alumno por Carrera';
    const subtitle = readOnly
      ? 'Consulte el alumno, la carrera y el año de inicio asociados.'
      : 'Actualice el alumno, la carrera o el año de inicio de esta inscripción.';

    return (
      <div className="md-page md-form-page">
        <Link className="md-form-page__back" to="/md-axc">
          <BackIcon />
          Volver al listado
        </Link>

        <h1 className="md-form-page__title">{title}</h1>
        <p className="md-form-page__subtitle">{subtitle}</p>

        <div className="md-form-page__card">
          <form className="md-form-page__form" onSubmit={this.handleSubmit} noValidate>
            <div className="md-form-page__feedback" aria-live="polite" role="status">
              {errorMessage ? <span className="md-form-page__error">{errorMessage}</span> : null}
              {!readOnly && loading ? (
                <span className="md-form-page__loading">Guardando cambios, espere un momento...</span>
              ) : null}
            </div>

            <div className="md-form-page__field">
              <span className="md-form-page__label">Alumno</span>
              {!readOnly ? (
                <button
                  type="button"
                  className="md-form-page__pick-btn"
                  onClick={this.handleShowStudentLookup}
                  disabled={isBusy}
                >
                  Seleccione el Alumno
                </button>
              ) : null}
              {showLookupStudent ? (
                <LookupAlumnos
                  selectStudent={this.handleSelectStudentItem}
                  hideLookup={this.handleHideStudentLookup}
                />
              ) : null}
              <input
                className="md-form-page__input"
                type="text"
                value={alumno.alumnoDni}
                readOnly
                disabled
                aria-label="DNI del alumno"
              />
              <input
                className="md-form-page__input"
                type="text"
                value={alumno.alumnoNombre}
                readOnly
                disabled
                aria-label="Nombre del alumno"
              />
            </div>

            <div className="md-form-page__field">
              <span className="md-form-page__label">Carrera</span>
              {!readOnly ? (
                <button
                  type="button"
                  className="md-form-page__pick-btn"
                  onClick={this.handleShowCarreraLookup}
                  disabled={isBusy}
                >
                  Seleccione la Carrera
                </button>
              ) : null}
              {showLookupCarreras ? (
                <LookupCarreras
                  selectItem={this.handleSelectCarreraItem}
                  hideLookup={this.handleHideCarreraLookup}
                />
              ) : null}
              <input
                className="md-form-page__input"
                type="text"
                value={carrera.carreraNombre}
                readOnly
                disabled
                aria-label="Carrera"
              />
            </div>

            <div className="md-form-page__field">
              <label className="md-form-page__label" htmlFor="axc-anio-inicio">
                Año de inicio en la carrera
              </label>
              <input
                id="axc-anio-inicio"
                className="md-form-page__input"
                type="text"
                name="anioInicio"
                inputMode="numeric"
                autoComplete="off"
                placeholder="Ej. 2024"
                value={anioInicio}
                onChange={this.handleAnioInicioChange}
                disabled={isBusy || readOnly}
                readOnly={readOnly}
                required
              />
            </div>

            {!readOnly ? (
              <div className="md-form-page__actions">
                <button type="submit" className="md-form-page__btn md-form-page__btn--primary" disabled={isBusy}>
                  Guardar cambios
                </button>
              </div>
            ) : null}
          </form>
        </div>
      </div>
    );
  }
}
